function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 176.5l-51.8-41.2-22.7-18.1-22.7 18.1-26.8 21.3-25 19.9 17.9 21.9 7.1-5.6V234H195v13.1c-.1 4.6-4 8.3-8.6 8.2H62.6c-7.2 0-13.1-5.6-13.1-12.5v-37.1h71.4V28.5H28.7v70.9H0v106.4h21.4v37.1c0 22.4 18.5 40.6 41.2 40.6h123.6c20.3 0 36.7-16.3 36.7-36.3V234h35.5v-41.2l7.1 5.7 18-22zM57.1 56.7h35.4v120.5H78.4v-78H57.1V56.7zM50 177.2H29.3v-49.6H50v49.6zm180.1 28.4h-42.5v-35.3l21.2-16.9 21.2 16.9.1 35.3z"
})));